const publicRoutes = [
  '',
  'faq',
  'leaderboard',
  'leaderboards/bootcamp',
  'leaderboards/elite-gamer-showdown',
  'leaderboards/elite-gamer-showdown-mobile',
  'leaderboards/esports',
  'leaderboards/flick',
  'leaderboards/follow-through',
  'leaderboards/speed',
  'leaderboards/tracking',
  'sign-in',
  'sign-out',
  'privacy-policy',
  'reset',
  'support',
  'terms-of-service',
]

const scoreboardRoutes = [
  'custom-games',
  'elite-gamer-showdown',
  'flick',
  'follow-through',
  'learning',
  'net-train',
  'speed',
  'stationary',
  'tracking',
]

const supportRoutes = [
  'reset',
  'support',
  'verification',
]

const targetOverlayRoutes = [
  'learning',
  'flick',
  'follow-through',
  'speed',
  'tracking',
]

exports.publicRoutes = publicRoutes
exports.scoreboardRoutes = scoreboardRoutes
exports.supportRoutes = supportRoutes
exports.targetOverlayRoutes = targetOverlayRoutes



// WEBPACK FOOTER //
// ./src/app/const/routes.js